export default {
    contact_us: {
      name: 'ติดต่อเรา',
      fields: {
        full_name: 'ชื่อ-นามสกุล',
        phone: 'เบอร์โทรศัพท์',
        line_id: 'ไอดีไลน์',
        email: 'อีเมล',
        subject: 'เรื่องที่สอบถาม',
        message: 'เนื้อหาที่สอบถาม',
        accept: 'ยอมรับข้อกำนดและเงื่อนไข',
        create_at: 'วันที่สร้าง',
        // type: { label: 'ประเภท', choices: { common: 'ส่วนกลาง', branch: 'สาขา' } },
        // notification: 'แจ้งเตือน',
        // note: 'คอนเทนท์ของคุณจะยังไม่ถูกเผยแพร่จนกว่าจะได้รับการอนุมัติ',
        note: '',
      },
      create: { title: 'สอบถามข้อมูลเพิ่มเติม' },
      show: { title: 'รายละเอียดการสอบถาม' },
      accept: {
        title: 'ยอมรับข้อกำนดและเงื่อนไขที่กำหนด',
        choices: {
          true: 'ยอมรับข้อกำนดและเงื่อนไขที่กำหนด',
          false: 'ไม่ยอมรับข้อกำนดและเงื่อนไขที่กำหนด',
        }
      },
  
      // order: { title: 'จัดการลำดับ' },

    //   viewer: {
    //     guest: 'ผู้ใช้ทั่วไป',
    //     branch: 'name_th',
    //     from: 'ผู้เข้าชมจาก',
    //     views: 'จำนวนผู้เข้าชม',
    //     all_views: 'ยอดเข้าชมทั้งหมด',
    //   },
    },
  }
  